module.exports = __webpack_public_path__ + "static/img/KN.5ad606f9.png";